<div class="dialog-top">
  <h2 mat-dialog-title>{{ 'Links' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="d-flex flex-column gap-2">
    <div class="d-flex flex-row gap-2" *ngFor="let link of links">
      <a [href]="link.url" target="_blank">
        {{ link.label }}
      </a>
      <mat-icon class="copy-icon" (click)="onCopyLink(link.url)" matTooltip="{{ 'Copy' | translate }}">content_copy</mat-icon>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onConfirm()">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
